<template>
  <div class="live-call-wrapper">
    <div id="video-container" class="video-area"></div>
    <div class="control-bar">
      <button @click="toggleMic">{{ micEnabled ? "🎤" : "🔇" }}</button>
      <button @click="toggleCamera">{{ cameraEnabled ? "📷" : "🚫" }}</button>
      <button @click="shareScreen">🖥️</button>
      <button @click="leaveSession" class="end-btn">🚪</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import AgoraRTC from "agora-rtc-sdk-ng";

const micEnabled = ref(true);
const cameraEnabled = ref(true);
let client;
let localTracks = [];

onMounted(async () => {
  const sessionData = JSON.parse(
    sessionStorage.getItem("liveSessionData") || "{}"
  );
  if (!sessionData.token) {
    alert("لا توجد بيانات للمكالمة!");
    window.close();
    return;
  }

  client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

  try {
    await client.join(
      "YOUR_APP_ID",
      sessionData.channel_name,
      sessionData.token,
      sessionData.uid
    );
    localTracks = await AgoraRTC.createMicrophoneAndCameraTracks();
    localTracks[1].play("video-container");
    await client.publish(localTracks);
  } catch (err) {
    console.error("Error joining call:", err);
  }
});

onBeforeUnmount(async () => {
  await leaveSession();
});

async function toggleMic() {
  if (localTracks[0]) {
    micEnabled.value = !micEnabled.value;
    await localTracks[0].setEnabled(micEnabled.value);
  }
}

async function toggleCamera() {
  if (localTracks[1]) {
    cameraEnabled.value = !cameraEnabled.value;
    await localTracks[1].setEnabled(cameraEnabled.value);
  }
}

async function shareScreen() {
  try {
    const screenTrack = await AgoraRTC.createScreenVideoTrack();

    await client.unpublish(localTracks[1]);
    localTracks[1].stop();
    localTracks[1].close();

    localTracks[1] = screenTrack;
    localTracks[1].play("video-container");
    await client.publish([screenTrack]);

    screenTrack.on("track-ended", async () => {
      const [mic, camera] = await AgoraRTC.createMicrophoneAndCameraTracks();
      localTracks[1] = camera;
      camera.play("video-container");
      await client.publish([camera]);
    });
  } catch (err) {
    console.error("Screen share error:", err);
  }
}

async function leaveSession() {
  for (const track of localTracks) {
    track.stop();
    track.close();
  }
  localTracks = [];
  await client.leave();
  window.close();
}
</script>

<style scoped>
.live-call-wrapper {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: black;
}
.video-area {
  flex: 1;
  background: #000;
}
.control-bar {
  background: rgba(0, 0, 0, 0.7);
  padding: 10px;
  display: flex;
  justify-content: center;
  gap: 10px;
}
.end-btn {
  background: red;
  color: white;
}
</style>
